import { render } from "./MaoAlert.vue?vue&type=template&id=97b0d0ae&scoped=true"
import script from "./MaoAlert.vue?vue&type=script&lang=js"
export * from "./MaoAlert.vue?vue&type=script&lang=js"

import "./MaoAlert.vue?vue&type=style&index=0&id=97b0d0ae&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97b0d0ae"]])

export default __exports__